/**
 * Câmera frontal do tablet para o "espelho" do telão do Menu Resolução (Pixel 3).
 * A imagem fica só no aparelho: nada é gravado nem enviado ao backend
 * (docs/menuresolucao-integracao.md, seção 10).
 */

/** Abre a câmera frontal sem áudio. Sem câmera ou sem permissão, devolve `null`. */
export async function abrirCamera ({ navegador = globalThis.navigator } = {}) {
    const midia = navegador?.mediaDevices;
    if (!midia?.getUserMedia) return null;
    try {
        return await midia.getUserMedia({
            video: { facingMode: 'user', width: { ideal: 1280 }, height: { ideal: 720 } },
            audio: false
        });
    } catch (falha) {
        console.warn('[Câmera] não foi possível abrir a câmera frontal.', falha);
        return null;
    }
}

/** Libera a câmera (apaga a luz do aparelho). Aceita `null`. */
export function fecharCamera (stream) {
    stream?.getTracks?.().forEach((faixa) => faixa.stop());
}

/**
 * Recorte que preenche (cover) a área `largura × altura` a partir de um vídeo `w × h`,
 * centrado. Devolve `{ x, y, largura, altura, escala }` no espaço do vídeo.
 */
export function recorteCover ({ w, h, largura, altura }) {
    const alvo = largura / altura;
    let cw = w, ch = h;
    if (w / h > alvo) cw = h * alvo; else ch = w / alvo;
    return { x: (w - cw) / 2, y: (h - ch) / 2, largura: cw, altura: ch, escala: largura / cw };
}
